import { render, staticRenderFns } from "./bankInfo.vue?vue&type=template&id=efb0687c&scoped=true"
import script from "./bankInfo.vue?vue&type=script&lang=js"
export * from "./bankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb0687c",
  null
  
)

export default component.exports